
(function(){
  var cv = document.getElementById('scene');
  var ctx = cv.getContext('2d');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var W=0,H=0,DPR=1,hY=0,boatSf=0,starX=0,starY=0;
  var stars=[], nebula=[];
  function rand(a,b){return a+Math.random()*(b-a);}
  function setup(){
    DPR = Math.min(window.devicePixelRatio||1, 2);
    W = cv.clientWidth; H = cv.clientHeight;
    cv.width = W*DPR; cv.height = H*DPR;
    ctx.setTransform(DPR,0,0,DPR,0,0);
    var pf=document.querySelector('.proof');
    if(W<=640){
      var sfm=Math.max(2.8, Math.min(5.4, W/116));   // width-based: stable when only height changes on scroll
      boatSf=sfm;
      var clr=26;                 // visible gap between lowest button and boat top
      var bb=H*0.58;
      var act=document.querySelector('.actions');
      if(act){var r=act.getBoundingClientRect(); if(r.height>0){ bb=r.bottom; }}
      // the stats float LOW in the water, fully inside the scene (never clipped by the section edge)
      var pfH   = pf ? pf.offsetHeight : 56;
      var botPad = Math.max(40, H*0.045);         // open water below the stats, down to the section edge
      var statsTop = H - pfH - botPad;
      var waterGap = Math.max(44, H*0.05);        // clear band of water between the hull and the stats
      hY = bb + (37.4*sfm+6) + clr;   // boat top (= hY - mast) sits clr px below the lowest button
      hY = Math.max(hY, H*0.5);
      hY = Math.min(hY, statsTop - waterGap);      // boat always floats ABOVE the stats, with water between
      if(pf){ pf.style.top = statsTop+'px'; pf.style.bottom='auto'; }
    } else {
      hY = H*0.78;
      if(pf){ var mid=hY+(H-hY)*0.5; pf.style.top=(mid - pf.offsetHeight/2)+'px'; pf.style.bottom='auto'; }
    }
    // lodestar position — computed once in canvas coords so it scrolls with the canvas (like the boat)
    starX=W*0.6; starY=H*0.16;
    var _sk=document.getElementById('kw');
    if(_sk){var sr=_sk.getBoundingClientRect(); if(sr.width>0){
      var scr=cv.getBoundingClientRect();
      starX=(sr.left+sr.width/2)-scr.left;
      var skTop=sr.top-scr.top;
      if(W<=640){
        var sRa=W*0.12, snavB=H*0.11, snavc=document.querySelector('.nav-cta');
        if(snavc){var snr=snavc.getBoundingClientRect(); if(snr.height>0) snavB=snr.bottom-scr.top;}
        var sLo=snavB+sRa+8, sHi=skTop-30;
        starY=Math.min(sHi, Math.max(sLo, (snavB+skTop)/2));
      } else {
        var sClr=Math.min(W*0.07,56)+12, sDes=skTop-H*0.045;
        starY=Math.min(sDes, skTop-sClr);
      }
      if(starY<18)starY=18;
    }}
    stars=[];
    var n = Math.round(W*H/4200);
    for(var i=0;i<n;i++){
      var y = rand(0, hY*0.98);
      var horizonFade = Math.min(1, (hY - y)/(hY*0.5)+0.25);
      stars.push({x:rand(0,W), y:y, r:rand(0.3,1.7)*(0.7+0.5*Math.random()),
        base:rand(0.25,0.95)*horizonFade, sp:rand(0.6,2.2), ph:rand(0,6.28)});
    }
    nebula=[];
    var cx=W*0.42, cy=hY*0.42;
    for(var j=0;j<Math.round(n*0.35);j++){
      var a=rand(0,6.28), d=Math.abs(rand(-1,1))*W*0.18;
      var nx=cx+Math.cos(a)*d*1.6+rand(-30,30);
      var ny=cy+Math.sin(a)*d*0.5+rand(-18,18);
      if(ny<hY*0.95) nebula.push({x:nx,y:ny,r:rand(0.2,0.9),base:rand(0.05,0.32),sp:rand(0.4,1.6),ph:rand(0,6.28)});
    }
  }
  function drawSky(){
    var g=ctx.createLinearGradient(0,0,0,hY);
    g.addColorStop(0,'#02030A'); g.addColorStop(0.55,'#04060F'); g.addColorStop(1,'#080F1C');
    ctx.fillStyle=g; ctx.fillRect(0,0,W,hY+2);
    var gl=ctx.createRadialGradient(W*0.5,hY,2,W*0.5,hY,W*0.5);
    gl.addColorStop(0,'rgba(170,186,214,0.16)'); gl.addColorStop(0.35,'rgba(120,140,180,0.07)'); gl.addColorStop(1,'rgba(120,140,180,0)');
    ctx.fillStyle=gl; ctx.fillRect(0,0,W,hY+2);
  }
  function drawStars(t){
    ctx.globalCompositeOperation='lighter';
    for(var i=0;i<nebula.length;i++){var s=nebula[i];var a=s.base*(0.6+0.4*Math.sin(t*0.001*s.sp+s.ph));ctx.fillStyle='rgba(200,210,235,'+a.toFixed(3)+')';ctx.fillRect(s.x,s.y,s.r,s.r);}
    for(var k=0;k<stars.length;k++){
      var st=stars[k]; var a=st.base*(0.55+0.45*Math.sin(t*0.001*st.sp+st.ph)); if(a<=0) continue;
      ctx.beginPath(); ctx.fillStyle='rgba(223,230,244,'+a.toFixed(3)+')'; ctx.arc(st.x,st.y,st.r,0,6.2832); ctx.fill();
      if(st.r>1.2){var hg=ctx.createRadialGradient(st.x,st.y,0,st.x,st.y,st.r*4);hg.addColorStop(0,'rgba(210,222,245,'+(a*0.5).toFixed(3)+')');hg.addColorStop(1,'rgba(210,222,245,0)');ctx.fillStyle=hg;ctx.fillRect(st.x-st.r*4,st.y-st.r*4,st.r*8,st.r*8);}
    }
    ctx.globalCompositeOperation='source-over';
  }
  function drawLodestar(t){
    var x=starX||W*0.6, y=starY||H*0.16;
    var pulse=0.85+0.15*Math.sin(t*0.0016);
    ctx.globalCompositeOperation='lighter';
    var mob=W<=640;
    var R=(mob?W*0.12:W*0.10)*pulse;
    var g=ctx.createRadialGradient(x,y,0,x,y,R);
    var a0=(mob?1.0:0.9), a1=(mob?0.58:0.45), a2=(mob?0.18:0.12);
    g.addColorStop(0,'rgba(248,216,140,'+a0+')');g.addColorStop(0.12,'rgba(239,195,106,'+a1+')');g.addColorStop(0.4,'rgba(239,195,106,'+a2+')');g.addColorStop(1,'rgba(239,195,106,0)');
    ctx.fillStyle=g; ctx.fillRect(x-R,y-R,R*2,R*2);
    ctx.strokeStyle='rgba(248,216,140,'+((mob?0.62:0.5)*pulse).toFixed(2)+')'; ctx.lineWidth=mob?1.3:1;
    var L=(mob ? W*0.062 : Math.min(W*0.024,36))*pulse;
    ctx.beginPath(); ctx.moveTo(x-L,y);ctx.lineTo(x+L,y);ctx.moveTo(x,y-L);ctx.lineTo(x,y+L);
    var l2=L*0.42; ctx.moveTo(x-l2,y-l2);ctx.lineTo(x+l2,y+l2);ctx.moveTo(x-l2,y+l2);ctx.lineTo(x+l2,y-l2); ctx.stroke();
    ctx.fillStyle='rgba(255,243,214,'+pulse.toFixed(2)+')'; ctx.beginPath();ctx.arc(x,y,(mob?2.8:2.2),0,6.2832);ctx.fill();
    ctx.globalCompositeOperation='source-over';
  }
  function drawWater(t){
    var g=ctx.createLinearGradient(0,hY,0,H);
    g.addColorStop(0,'#070E1A'); g.addColorStop(0.45,'#04090F'); g.addColorStop(1,'#010308');
    ctx.fillStyle=g; ctx.fillRect(0,hY,W,H-hY);
    ctx.globalCompositeOperation='lighter';
    var rows=Math.round((H-hY)/8);
    for(var i=0;i<rows;i++){
      var depth=i/rows; var y=hY + (H-hY)*(depth*0.4+depth*depth*0.6);
      var a=0.022+0.085*depth; ctx.strokeStyle='rgba(158,180,216,'+a.toFixed(3)+')'; ctx.lineWidth=1+depth*0.7;
      ctx.beginPath(); var amp=1+depth*5;
      for(var x=0;x<=W;x+=12){var ry=y+Math.sin(x*0.02+t*0.001*(1+depth)+depth*4)*amp*0.55; if(x===0)ctx.moveTo(x,ry);else ctx.lineTo(x,ry);}
      ctx.stroke();
    }
    // soft rolling swells
    for(var s=0;s<3;s++){
      var sd=0.30+s*0.24;
      var yy=hY+(H-hY)*(sd*0.4+sd*sd*0.6);
      var sp=t*0.00035*(1+s*0.4)+s*1.3;
      var wl=0.0055+s*0.0012;
      var samp=5+s*8;
      ctx.lineWidth=10+s*8; ctx.strokeStyle='rgba(150,172,210,'+(0.020-s*0.003).toFixed(3)+')';
      ctx.beginPath();
      for(var sx=0;sx<=W;sx+=12){var sy=yy+Math.sin(sx*wl+sp)*samp*0.6+Math.sin(sx*wl*2.2+sp*1.4)*samp*0.2; if(sx===0)ctx.moveTo(sx,sy);else ctx.lineTo(sx,sy);}
      ctx.stroke();
      ctx.lineWidth=1.2; ctx.strokeStyle='rgba(178,198,230,'+(0.055-s*0.012).toFixed(3)+')';
      ctx.beginPath();
      for(var cx2=0;cx2<=W;cx2+=12){var cy2=yy+Math.sin(cx2*wl+sp)*samp*0.6+Math.sin(cx2*wl*2.2+sp*1.4)*samp*0.2-1.6; if(cx2===0)ctx.moveTo(cx2,cy2);else ctx.lineTo(cx2,cy2);}
      ctx.stroke();
    }
    ctx.globalCompositeOperation='source-over';
  }
  function drawBoat(t){
    var isMobile = W <= 640; var bx=W*0.5, sf, by;
    var bob=reduce?0:Math.sin(t*0.0009)*(isMobile?3.2:3.0);
    var rot=reduce?0:Math.sin(t*0.0009+1)*(isMobile?0.01:0.009);
    if(isMobile){ sf=boatSf>0?boatSf:Math.max(2.4, Math.min(6.4, Math.min(W,H)/150)); by=hY+bob; }
    else { sf=Math.max(2.8, Math.min(4.0, Math.min(W,H)/190)); by=hY+bob; }
    ctx.save(); ctx.translate(bx,by); ctx.rotate(rot); ctx.lineJoin='round'; ctx.lineCap='round';
    ctx.save(); ctx.globalCompositeOperation='lighter';
    var glow=ctx.createRadialGradient(0,-12*sf,0,0,-12*sf,26*sf); glow.addColorStop(0,'rgba(170,190,225,0.10)'); glow.addColorStop(1,'rgba(170,190,225,0)');
    ctx.fillStyle=glow; ctx.fillRect(-30*sf,-40*sf,60*sf,46*sf); ctx.restore();
    var bright='#CAD4E2', mid='#AEB9CA', dark='#7E8798';
    var hg=ctx.createLinearGradient(0,-4*sf,0,1*sf); hg.addColorStop(0,bright); hg.addColorStop(1,dark);
    ctx.beginPath();
    ctx.moveTo(19*sf,-3.2*sf);
    ctx.bezierCurveTo(12*sf,-3.9*sf, 2*sf,-3.3*sf, -6*sf,-2.7*sf);
    ctx.bezierCurveTo(-12*sf,-2.3*sf, -15*sf,-2.1*sf, -16.5*sf,-1.7*sf);
    ctx.lineTo(-16.3*sf,-0.1*sf);
    ctx.bezierCurveTo(-10*sf,0.7*sf, 9*sf,0.9*sf, 16*sf,0.4*sf);
    ctx.bezierCurveTo(17.6*sf,0.2*sf, 18.5*sf,-1.6*sf, 19*sf,-3.2*sf);
    ctx.closePath(); ctx.fillStyle=hg; ctx.fill();
    ctx.beginPath(); ctx.moveTo(-2.5*sf,-3.1*sf); ctx.lineTo(-3.4*sf,-5.4*sf); ctx.lineTo(6.5*sf,-5.4*sf); ctx.lineTo(8*sf,-3.1*sf); ctx.closePath(); ctx.fillStyle=mid; ctx.fill();
    ctx.beginPath(); ctx.moveTo(-0.9*sf,-4.5*sf); ctx.lineTo(-0.4*sf,-34*sf); ctx.lineTo(0.3*sf,-34*sf); ctx.lineTo(0.9*sf,-4.5*sf); ctx.closePath(); ctx.fillStyle=bright; ctx.fill();
    ctx.beginPath(); ctx.moveTo(-0.4*sf,-7.4*sf); ctx.bezierCurveTo(-6*sf,-6.6*sf,-11*sf,-6.0*sf,-14*sf,-5.4*sf); ctx.lineTo(-14*sf,-4.4*sf); ctx.bezierCurveTo(-11*sf,-4.7*sf,-6*sf,-5.3*sf,-0.4*sf,-6.2*sf); ctx.closePath(); ctx.fillStyle=mid; ctx.fill();
    ctx.strokeStyle='rgba(192,202,218,0.85)'; ctx.lineWidth=0.5*sf;
    ctx.beginPath(); ctx.moveTo(0,-33.5*sf); ctx.lineTo(18.6*sf,-3.3*sf); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0,-33.5*sf); ctx.lineTo(-16.2*sf,-1.7*sf); ctx.stroke();
    ctx.lineWidth=0.45*sf; ctx.beginPath(); ctx.moveTo(-3.4*sf,-21*sf); ctx.lineTo(3.4*sf,-21*sf); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0,-33.5*sf); ctx.lineTo(3.4*sf,-21*sf); ctx.lineTo(6*sf,-3.2*sf); ctx.moveTo(0,-33.5*sf); ctx.lineTo(-3.4*sf,-21*sf); ctx.lineTo(-7*sf,-2.6*sf); ctx.stroke();
    ctx.lineWidth=0.5*sf; ctx.beginPath(); ctx.moveTo(17.5*sf,-3.4*sf); ctx.lineTo(19.3*sf,-4.6*sf); ctx.stroke();
    // furled jib (roller genoa) hugging the forestay
    var jtx=0, jty=-33.5, jbx=18.6, jby=-3.3, jdx=jbx-jtx, jdy=jby-jty, jL=Math.hypot(jdx,jdy), jpx=-jdy/jL, jpy=jdx/jL, jwt=0.5, jwb=1.25;
    var jg=ctx.createLinearGradient(0,-30*sf,16*sf,-4*sf); jg.addColorStop(0,bright); jg.addColorStop(1,dark);
    ctx.beginPath();
    ctx.moveTo((jtx+jpx*jwt)*sf,(jty+jpy*jwt)*sf);
    ctx.lineTo((jtx-jpx*jwt)*sf,(jty-jpy*jwt)*sf);
    ctx.lineTo((jbx-jpx*jwb)*sf,(jby-jpy*jwb)*sf);
    ctx.lineTo((jbx+jpx*jwb)*sf,(jby+jpy*jwb)*sf);
    ctx.closePath(); ctx.fillStyle=jg; ctx.fill();
    // waterline boot-stripe
    ctx.strokeStyle='rgba(64,74,90,0.9)'; ctx.lineWidth=0.7*sf;
    ctx.beginPath(); ctx.moveTo(-16.3*sf,-0.05*sf); ctx.bezierCurveTo(-10*sf,0.75*sf,9*sf,0.95*sf,16*sf,0.45*sf); ctx.stroke();
    // lifelines + stanchions along the side deck
    ctx.strokeStyle='rgba(192,202,218,0.6)'; ctx.lineWidth=0.3*sf;
    var stn=[9,12.5,15.8]; ctx.beginPath();
    for(var si=0;si<stn.length;si++){ ctx.moveTo(stn[si]*sf,-3.3*sf); ctx.lineTo(stn[si]*sf,-5.3*sf); }
    ctx.stroke();
    ctx.beginPath(); ctx.moveTo(8*sf,-5.1*sf); ctx.lineTo(15.8*sf,-5.3*sf); ctx.lineTo(19.2*sf,-4.7*sf); ctx.stroke();
    // warm cabin light + masthead anchor light
    ctx.save(); ctx.globalCompositeOperation='lighter';
    var cwg=ctx.createRadialGradient(3.2*sf,-4.4*sf,0,3.2*sf,-4.4*sf,3*sf); cwg.addColorStop(0,'rgba(255,221,158,0.5)'); cwg.addColorStop(1,'rgba(255,221,158,0)');
    ctx.fillStyle=cwg; ctx.fillRect(-1*sf,-7*sf,9*sf,4.5*sf);
    var alg=ctx.createRadialGradient(0,-34*sf,0,0,-34*sf,3.4*sf); alg.addColorStop(0,'rgba(255,243,212,0.85)'); alg.addColorStop(1,'rgba(255,243,212,0)');
    ctx.fillStyle=alg; ctx.beginPath(); ctx.arc(0,-34*sf,3.4*sf,0,Math.PI*2); ctx.fill();
    ctx.fillStyle='rgba(255,249,230,0.95)'; ctx.beginPath(); ctx.arc(0,-34*sf,0.7*sf,0,Math.PI*2); ctx.fill();
    ctx.restore();
    ctx.restore();
  }
  var shoot=null, shootNext=0;
  function drawShooting(t){
    if(reduce) return;
    if(shootNext===0){ shootNext=t+4000+Math.random()*5000; }
    if(!shoot && t>=shootNext){
      var fromLeft=Math.random()<0.6;
      var sx=fromLeft? W*(0.05+Math.random()*0.30) : W*(0.65+Math.random()*0.30);
      var sy=hY*(0.08+Math.random()*0.26);
      var ang=fromLeft? (0.30+Math.random()*0.18) : (Math.PI-(0.30+Math.random()*0.18));
      var spd=(W*0.013)*(0.8+Math.random()*0.5);
      shoot={x:sx,y:sy,ux:Math.cos(ang),uy:Math.sin(ang),spd:spd,life:0,max:620+Math.random()*340,len:90+Math.random()*80,last:t};
    }
    if(shoot){
      var dt=Math.min(48,t-shoot.last); shoot.last=t;
      var step=shoot.spd*dt/16;
      shoot.x+=shoot.ux*step; shoot.y+=shoot.uy*step; shoot.life+=dt;
      var p=shoot.life/shoot.max;
      var alpha=p<0.18? (p/0.18) : (1-(p-0.18)/0.82); if(alpha<0)alpha=0;
      if(alpha>0 && shoot.y<hY*0.60){
        var hx=shoot.x, hy=shoot.y, tx=hx-shoot.ux*shoot.len, ty=hy-shoot.uy*shoot.len;
        ctx.globalCompositeOperation='lighter';
        var g=ctx.createLinearGradient(hx,hy,tx,ty);
        g.addColorStop(0,'rgba(255,250,235,'+(0.9*alpha).toFixed(3)+')');
        g.addColorStop(0.4,'rgba(220,228,250,'+(0.32*alpha).toFixed(3)+')');
        g.addColorStop(1,'rgba(220,228,250,0)');
        ctx.strokeStyle=g; ctx.lineWidth=1.7; ctx.lineCap='round';
        ctx.beginPath(); ctx.moveTo(hx,hy); ctx.lineTo(tx,ty); ctx.stroke();
        var hgl=ctx.createRadialGradient(hx,hy,0,hx,hy,6);
        hgl.addColorStop(0,'rgba(255,252,240,'+(0.9*alpha).toFixed(3)+')'); hgl.addColorStop(1,'rgba(255,252,240,0)');
        ctx.fillStyle=hgl; ctx.fillRect(hx-6,hy-6,12,12);
        ctx.globalCompositeOperation='source-over';
      }
      if(p>=1 || shoot.x<-120 || shoot.x>W+120 || shoot.y>hY*0.58){ shoot=null; shootNext=t+9000+Math.random()*9000; }
    }
  }
  function frame(t){ ctx.clearRect(0,0,W,H); drawSky(); drawStars(t); drawShooting(t); drawLodestar(t); drawWater(t); drawBoat(t); if(!reduce) requestAnimationFrame(frame); }
  function start(){ setup(); requestAnimationFrame(frame); }
  var rt, lastW=window.innerWidth;
  window.addEventListener('resize',function(){
    var w=window.innerWidth;
    if(w===lastW) return;   // height-only change (mobile address bar on scroll) — keep boat/horizon fixed
    lastW=w; clearTimeout(rt); rt=setTimeout(setup,180);
  });
  window.addEventListener('load',function(){setTimeout(setup,60);});
  setTimeout(setup,1300);
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){setTimeout(setup,30);});}
  setTimeout(start, 30);
})();

;

(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- reveal + counters ----
  function runCount(el){
    var to=parseFloat(el.dataset.count), suf=el.dataset.suffix||'', pre=el.dataset.prefix||'';
    var dur=1300, st=null;
    function step(ts){ if(!st)st=ts; var p=Math.min(1,(ts-st)/dur); var e=1-Math.pow(1-p,3);
      el.textContent=pre+Math.round(to*e)+suf; if(p<1)requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); if(e.target.dataset.count!==undefined) runCount(e.target); io.unobserve(e.target); }});},{threshold:.18});
  document.querySelectorAll('.reveal,[data-count]').forEach(function(el){io.observe(el);});

  // ---- live orders ----
  var feed=document.getElementById('ordFeed'), totalEl=document.getElementById('ordTotal');
  var names=['Emma','Liam','Sofie','Noah','Julia','Lars','Anouk','Felix','Ingrid','Daan','Maja','Finn','Lotte','Oskar','Nora','Sven','Yara','Ravi','Bram','Elin','Tobias','Sara','Mila','Jens','Pim','Saga','Aleksander','Wiktoria','Mette','Ole'];
  var brandPool=['HappyFlops','HappyFlops','HappyFlops','HappyFlops','HappyFlops','HappyFlops','VagiVital','VagiVital','Skrub','Wonderboo'];
  var total=81765874;
  function fmt(n){return '€'+Math.round(n).toLocaleString('en-US');}
  function pickName(){
    var shown={}, rows=feed.children;
    for(var i=0;i<rows.length;i++){ var s=rows[i].querySelector('.nm'); if(s){ shown[s.textContent.split(' ')[0]]=1; } }
    var n,g=0; do{ n=names[Math.floor(Math.random()*names.length)]; g++; }while(shown[n] && g<60);
    return n;
  }
  function addOrder(){
    var br=brandPool[Math.floor(Math.random()*brandPool.length)];
    var amt = br==='HappyFlops'
      ? Math.round(38+Math.pow(Math.random(),2.3)*111)   // ~60-70 typical, max €149
      : Math.round(49+Math.random()*201);
    total+=amt;
    totalEl.textContent=fmt(total);
    var li=document.createElement('li'); li.className='ord';
    var nm=pickName();
    li.innerHTML='<div class="who"><span class="nm">'+nm+' &middot; new order</span><span class="mt">'+br+' &middot; just now</span></div><span class="amt">+$'+amt+'</span>';
    feed.insertBefore(li,feed.firstChild);
    while(feed.children.length>6) feed.removeChild(feed.lastChild);
  }
  var seeded=false;
  var oio=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting && !seeded){ seeded=true; for(var i=0;i<5;i++) addOrder(); if(!reduce) setInterval(addOrder, 1600+Math.random()*1100); }});},{threshold:.25});
  var op=document.getElementById('ordersPanel'); if(op) oio.observe(op);

  // ---- hero revenue count-up ----
  var heroNum=document.getElementById('heroNum');
  if(heroNum){
    if(reduce){ heroNum.textContent='€55M+'; }
    else {
      var hStart=null, hDur=1700;
      function heroStep(ts){ if(!hStart)hStart=ts; var p=Math.min(1,(ts-hStart)/hDur); var e=1-Math.pow(1-p,3);
        heroNum.textContent='€'+Math.round(e*55)+'M+'; if(p<1) requestAnimationFrame(heroStep); }
      setTimeout(function(){ requestAnimationFrame(heroStep); }, 450);
    }
  }

  // ---- compass needle ----
  var needle=document.getElementById('needle');
  if(needle && !reduce){
    (function sp(t){ var a=7*Math.sin(t/950)+3*Math.sin(t/330)+1.5*Math.sin(t/140);
      needle.setAttribute('transform','rotate('+a.toFixed(2)+' 210 150)'); requestAnimationFrame(sp); })(0);
  }

  // ---- apply form (Formspree AJAX) ----
  var form=document.getElementById('applyForm'), btn=document.getElementById('applyBtn'), thanks=document.getElementById('thanks');
  if(form){ form.addEventListener('submit',function(e){
    e.preventDefault();
    var ok=true; form.querySelectorAll('[required]').forEach(function(f){ if(!f.value){ok=false; f.style.borderColor='rgba(201,122,90,.7)';} else { f.style.borderColor=''; } });
    if(!ok) return;
    var orig=btn.innerHTML; btn.disabled=true; btn.style.opacity='.7'; btn.textContent='Sending\u2026';
    fetch(form.action,{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
      .then(function(res){
        if(res.ok){ form.style.display='none'; thanks.style.display='block'; thanks.scrollIntoView({behavior:'smooth',block:'center'}); }
        else { btn.disabled=false; btn.style.opacity=''; btn.textContent='Something went wrong \u2014 try again'; setTimeout(function(){btn.innerHTML=orig;},3500); }
      })
      .catch(function(){ btn.disabled=false; btn.style.opacity=''; btn.textContent='Network error \u2014 try again'; setTimeout(function(){btn.innerHTML=orig;},3500); });
  }); }
})();

;

(function(){
  var t=document.getElementById('navToggle'), m=document.getElementById('navMenu');
  if(t&&m){
    function close(){ m.classList.remove('open'); t.classList.remove('on'); t.setAttribute('aria-expanded','false'); }
    t.addEventListener('click',function(e){ e.stopPropagation(); var o=m.classList.toggle('open'); t.classList.toggle('on',o); t.setAttribute('aria-expanded',o?'true':'false'); });
    m.querySelectorAll('a').forEach(function(a){ a.addEventListener('click',close); });
    document.addEventListener('click',function(e){ if(!m.contains(e.target)&&!t.contains(e.target)) close(); });
  }
  // sticky header blur on scroll
  var hdr=document.getElementById('siteHeader');
  if(hdr){ var onScroll=function(){ hdr.classList.toggle('scrolled', window.scrollY>30); }; onScroll(); window.addEventListener('scroll',onScroll,{passive:true}); }
  // auto-updating application quarter (rolls to next Q in the final month of a quarter)
  var q=document.getElementById('qLabel');
  if(q){ var d=new Date(), mo=d.getMonth(), yr=d.getFullYear(), qt=Math.floor(mo/3)+1;
    if(mo%3===2){ qt++; if(qt>4){ qt=1; yr++; } }
    q.textContent='Q'+qt+' '+yr; }
})();

;(function(){
  /* Keep the fixed homepage header below the announcement bar */
  var bar=document.querySelector('.ls-announce');
  var hdr=document.querySelector('.site-header');
  if(!hdr) return;
  function adj(){ var h=bar?bar.offsetHeight:0; hdr.style.top=Math.max(0,h-(window.scrollY||window.pageYOffset||0))+'px'; }
  adj();
  window.addEventListener('scroll',adj,{passive:true});
  window.addEventListener('resize',adj);
})();
